import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesComponent } from './main/pages/pages.component';
import { ServicesComponent } from './main/pages/services/services.component';
import { AppsComponent } from './main/pages/apps/apps.component';
import { ContainerSpecificationComponent } from './main/pages/apps/container-specification/container-specification.component';
import { EmissionCalculatorComponent } from './main/pages/apps/emission-calculator/emission-calculator.component';
import { FreightVolumeCalculatorComponent } from './main/pages/apps/freight-volume-calculator/freight-volume-calculator.component';
import { ContainerVesselTrackerComponent } from './main/pages/apps/container-vessel-tracker/container-vessel-tracker.component';
import { IncoTermsComponent } from './main/pages/apps/inco-terms/inco-terms.component';
import { ShippingGlossaryComponent } from './main/pages/apps/shipping-glossary/shipping-glossary.component';
import { HeaderComponent } from './main/header/header.component';
import { FooterComponent } from './main/footer/footer.component';
import { OtherAppsComponent } from './main/pages/apps/other-apps/other-apps.component';
import { AirServiceComponent } from './main/pages/services/air-service/air-service.component';
import { OceanServiceComponent } from './main/pages/services/ocean-service/ocean-service.component';
import { ValueAddedServiceComponent } from './main/pages/services/value-added-service/value-added-service.component';
import { VerticalsComponent } from './main/pages/services/verticals/verticals.component';
import { HomePageComponent } from './main/pages/home-page/home-page.component';
import { WhySatComponent } from './main/pages/home-page/component/why-sat/why-sat.component';
import { HomeAppsComponent } from './main/pages/home-page/component/home-apps/home-apps.component';
import { LatestNewsComponent } from './main/pages/home-page/component/latest-news/latest-news.component';
import { OurServicesComponent } from './main/pages/home-page/component/our-services/our-services.component';
import { AboutComponent } from './main/pages/about/about.component';
import { NewsComponent } from './main/pages/news/news.component';
import { ContactComponent } from './main/pages/contact/contact.component';
import { ContactBannerComponent } from './main/pages/contact/contact-banner/contact-banner.component';
import { LocationTabsComponent } from './main/pages/contact/location-tabs/location-tabs.component';
import { AirServiceBannerComponent } from './main/pages/services/air-service/air-service-banner/air-service-banner.component';
import { AirServiceContentComponent } from './main/pages/services/air-service/air-service-content/air-service-content.component';
import { OceanServiceContentComponent } from './main/pages/services/ocean-service/ocean-service-content/ocean-service-content.component';
import { OceanServiceBannerComponent } from './main/pages/services/ocean-service/ocean-service-banner/ocean-service-banner.component';
import { VerticalsBannerComponent } from './main/pages/services/verticals/verticals-banner/verticals-banner.component';
import { VerticalsContentComponent } from './main/pages/services/verticals/verticals-content/verticals-content.component';
import { ValueAddedContentComponent } from './main/pages/services/value-added-service/value-added-content/value-added-content.component';
import { ValueAddedBannerComponent } from './main/pages/services/value-added-service/value-added-banner/value-added-banner.component';
import { AppsBannerComponent } from './main/pages/apps/apps-banner/apps-banner.component';
import { HomeBannerComponent } from './main/pages/home-page/component/home-banner/home-banner.component';
import { SatComponent } from './main/sat/sat.component';
import { AboutBannerComponent } from './main/pages/about/about-banner/about-banner.component';
import { AboutContentComponent } from './main/pages/about/about-content/about-content.component';
// import { PrivacyPolicyComponent } from './main/text-documents/privacy-policy/privacy-policy.component';
// import { AirwayBillConditionsComponent } from './main/text-documents/airway-bill-conditions/airway-bill-conditions.component';
import { DenmarkComponent } from './main/pages/contact/denmark/denmark.component';
import { NorwayComponent } from './main/pages/contact/norway/norway.component';
import { SwedenComponent } from './main/pages/contact/sweden/sweden.component';
import { FinlandComponent } from './main/pages/contact/finland/finland.component';
import { EstoniaComponent } from './main/pages/contact/estonia/estonia.component';
import { BlTermsConditionsComponent } from './main/pages/documents/bl-terms-conditions/bl-terms-conditions.component';
import { TermsOfUseComponent } from './main/pages/documents/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './main/pages/documents/privacy-policy/privacy-policy.component';
import { AirwayBillConditionsComponent } from './main/pages/documents/airway-bill-conditions/airway-bill-conditions.component';
import { SitemapComponent } from './main/pages/documents/sitemap/sitemap.component';



// SERVICE INJECT 
import {ApiServiceService } from './shared/services/api-service.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AuthInterceptor } from './shared/services/authconfig.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafehtmlDirective } from './shared/directive/safehtml.directive';
import { SafehtmlPipe } from './shared/pipe/safehtml.pipe';
import { UnconventionalCharterSolutionComponent } from './main/pages/home-page/component/latest-news/unconventional-charter-solution/unconventional-charter-solution.component';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaModule,ReCaptchaV3Service,RECAPTCHA_V3_SITE_KEY  ,RecaptchaFormsModule } from 'ng-recaptcha';
import { NotFoundComponent } from './main/not-found/not-found.component';



const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: 'localhost'// it is recommended to set your domain, for cookies to work properly
  },
  palette: {
    popup: {
      background: '#213654'
    },
    button: {
      background: '#e8882d'
    }
  },
  theme: 'edgeless',
  type: 'opt-out',

  elements:{
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}} 
      
    </span>
    `
  },
  content:{
    message: 'Our website uses cookies to improve your experience and we assume you are OK with this. If not, you may opt out by visiting the privacy settings of  your browser to disable cookies.'
  }
};



@NgModule({ declarations: [
        AppComponent,
        PagesComponent,
        ServicesComponent,
        AppsComponent,
        ContainerSpecificationComponent,
        EmissionCalculatorComponent,
        FreightVolumeCalculatorComponent,
        ContainerVesselTrackerComponent,
        IncoTermsComponent,
        HeaderComponent,
        FooterComponent,
        OtherAppsComponent,
        AirServiceComponent,
        OceanServiceComponent,
        ValueAddedServiceComponent,
        VerticalsComponent,
        HomePageComponent,
        WhySatComponent,
        HomeAppsComponent,
        LatestNewsComponent,
        OurServicesComponent,
        AboutComponent,
        NewsComponent,
        ContactComponent,
        ContactBannerComponent,
        LocationTabsComponent,
        AirServiceBannerComponent,
        AirServiceContentComponent,
        OceanServiceContentComponent,
        OceanServiceBannerComponent,
        VerticalsBannerComponent,
        VerticalsContentComponent,
        ValueAddedContentComponent,
        ValueAddedBannerComponent,
        ShippingGlossaryComponent,
        AppsBannerComponent,
        HomeBannerComponent,
        SatComponent,
        AboutBannerComponent,
        AboutContentComponent,
        PrivacyPolicyComponent,
        AirwayBillConditionsComponent,
        DenmarkComponent,
        NorwayComponent,
        SwedenComponent,
        FinlandComponent,
        EstoniaComponent,
        BlTermsConditionsComponent,
        TermsOfUseComponent,
        SitemapComponent,
        SafehtmlDirective,
        SafehtmlPipe,
        UnconventionalCharterSolutionComponent,
        NotFoundComponent
    ],
    bootstrap: [AppComponent], imports: [NgcCookieConsentModule.forRoot(cookieConfig),
        TranslateModule.forRoot(),
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        RecaptchaModule,
        RecaptchaFormsModule], providers: [
        ApiServiceService,
        ReCaptchaV3Service,
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: "RECAPTCHA_KEY" },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
